import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { makeApi } from "@/lib/api";
import { useT } from "@/i18n";

const TEXT = {
  es: { checking: "Confirmando tu pago...", paid: "¡Gracias! Tu Plan Familia está activo.", pending: "Tu pago todavía se está procesando. Revisa en unos minutos.", cancel: "Cancelaste el pago. Puedes intentarlo cuando quieras.", back: "Volver a Padres" },
  en: { checking: "Confirming your payment...", paid: "Thank you! Your Family Plan is active.", pending: "Your payment is still processing. Check again in a few minutes.", cancel: "You cancelled the payment. You can try again anytime.", back: "Back to Parents" },
};

export default function PaymentResult({ cancelled = false }) {
  const { lang } = useT();
  const tx = TEXT[lang];
  const [params] = useSearchParams();
  const [state, setState] = useState(cancelled ? "cancel" : "checking");
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    const id = params.get("session_id");
    if (cancelled || !id || !isLoaded) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const r = await makeApi(getToken).get(`/payments/status/${id}`);
        if (r.data.payment_status === "paid") return setState("paid");
      } catch {}
      if (tries >= 10) return setState("pending");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, cancelled, isLoaded, getToken]);

  return (
    <div className="min-h-[70vh] sky-bg flex flex-col items-center justify-center gap-6 px-4 text-center" data-testid="payment-result">
      <img src={state === "paid" ? "/img/lumi.webp" : "/img/spark.webp"} alt="" className="w-36 mascot-wiggle" />
      <p className="font-fredoka text-2xl sm:text-4xl font-bold bubble-text text-white max-w-2xl" data-testid={`payment-${state}`}>{tx[state]}</p>
      <Link to="/parents" className="glossy-btn inline-block bg-yellow-300 text-blue-900 font-fredoka font-bold text-xl px-8 py-3 rounded-full" data-testid="payment-back-btn">{tx.back}</Link>
    </div>
  );
}
